/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectChangeOrderCommandResult } from '../../models/create-project-change-order-command-result';

export interface ApiProjectChangeOrderCreateProjectChangeOrderPost$Params {
      body?: {
'ProjectId'?: string;
'No': string;
'ContractExtension'?: number;
'Date': string;
'Attachments'?: Array<Blob>;
}
}

export function apiProjectChangeOrderCreateProjectChangeOrderPost(http: HttpClient, rootUrl: string, params?: ApiProjectChangeOrderCreateProjectChangeOrderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectChangeOrderCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectChangeOrderCreateProjectChangeOrderPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectChangeOrderCommandResult>;
    })
  );
}

apiProjectChangeOrderCreateProjectChangeOrderPost.PATH = '/api/ProjectChangeOrder/CreateProjectChangeOrder';
